﻿import { NamedValueResponse } from '../../../shared/models/named-value-response.model'

export class Department extends NamedValueResponse {
}